import React, { useState, useEffect } from 'react';
import apiFetch from '../../../../utils/api';
import Preloader from '../../../../components/Preloader/Preloader';
import Pagination from '../../../../components/Pagination/Pagination';
import './AdminStyles.css';

const AdminTodayWithdrawals = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const fetchData = () => {
    setLoading(true);
    apiFetch(`/api/admin/withdrawals/today?page=${page}`)
      .then(res => res.json())
      .then(res => { 
        setData(res.withdrawals || []); 
        setTotalPages(res.totalPages || 1);
        setTotalCount(res.totalCount || 0);
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  };
  useEffect(fetchData, [page]);

  // Calculate today's total
  const todayTotal = data.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

  return (
    <div className="admin-page">
      <div className="admin-breadcrumb">🏠 / Admin / Today's Cleared Withdrawals</div>
      <h2 className="admin-title">Today's Cleared Withdrawals</h2>

      <div className="admin-stats-bar">
        <div className="admin-stat-chip green">{totalCount || data.length} Cleared Today</div>
        <div className="admin-stat-chip blue">Rs. {todayTotal.toLocaleString()} Total</div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Withdrawals Cleared Today</div>
        <div className="admin-card-body">
          {loading ? (
            <Preloader message="Fetching today's withdrawals..." fullScreen={false} />
          ) : data.length === 0 ? (
            <div className="admin-empty">No withdrawals cleared today</div>
          ) : (
            <>
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Username</th>
                      <th>Email</th>
                      <th>Amount</th>
                      <th>Description</th>
                      <th>Account #</th>
                      <th>Account Title</th>
                      <th>Team</th>
                      <th>Level</th>
                      <th>Payment Method</th>
                      <th>Status</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td><strong>{row.username}</strong></td>
                        <td>{row.email}</td>
                        <td><span className="user-balance-chip">Rs. {row.amount}</span></td>
                        <td><span style={{ color: 'var(--awp-accent)', fontWeight: '500' }}>Ads watch earning</span></td>
                        <td>{row.accountNumber || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.accountTitle || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.team || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className="status-badge approved">{row.userLevel}</span></td>
                        <td>{row.paymentMethod || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className="status-badge approved">{row.status}</span></td>
                        <td>{row.updatedAt}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination 
                currentPage={page} 
                totalPages={totalPages} 
                onPageChange={setPage} 
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminTodayWithdrawals;
